import React, { useEffect } from 'react';
import { PanelBar, PanelBarItem } from '@progress/kendo-react-layout';
import { useTranslation } from 'react-i18next';

function FAQ() {

    const { t, i18n, ready } = useTranslation("payment/faq", { useSuspense: false });

    useEffect(() => {
        if (ready) {
            // i18n.changeLanguage("en");
        }
    }, [ready])

    return (
        <PanelBar>
            <PanelBarItem
                title={t("question_1")}
                className="pricing-faq-accordion"
            >
                <div>
                    {t("answer_1")}
                    <a rel="noreferrer" href='https://www.codelessone.com/contact-us/' target='_blank'>&nbsp;{t("contact_us")}</a>
                </div>
            </PanelBarItem>
            <PanelBarItem
                title={t("question_2")}
                className="pricing-faq-accordion"
            >
                {t("answer_2")}
            </PanelBarItem>
            <PanelBarItem
                title={t("question_3")}
                className="pricing-faq-accordion"
            >
                {t("answer_3")}
            </PanelBarItem>
            <PanelBarItem
                title={t("question_4")}
                className="pricing-faq-accordion"
            >
                {t("answer_4")}
            </PanelBarItem>
            <PanelBarItem
                title={t("question_5")}
                className="pricing-faq-accordion"
            >
                <div>
                    {t("answer_5")}
                    <a rel="noreferrer" href='https://www.codelessone.com/contact-us/' target='_blank'>&nbsp;{t("contact_us")}</a>
                </div>
            </PanelBarItem>
        </PanelBar>
    )
}

export default FAQ;